import settingRoute from "./setting";
import home from './home'
import userCenter from './userCenter'
import promotion from "./promotion";
import brandManagement from './brandManagement'
import goodsManagement from './goodsManagement'
import discount from './discount'
import orderManagement from './orderManagement'
import accountsManagement from './accountsManagement'
import basicSetting from './basicSetting'
import hubManagement from "./hubManagement"
import provinceCityAgents from './provinceCityAgents'


let indexRoute = {
    path: '/',
    name: 'index',
    meta: {
        title: "首页",
        breadcrumb: true
    },
    redirect: {
        name: 'home'
    },
    component: (resolve) => {
        require(['@/views/Index'], resolve)
    },
    children: [
        settingRoute,
        home,
        userCenter,
        brandManagement,
        goodsManagement,
        discount,
        orderManagement,
        accountsManagement,
        basicSetting,
        hubManagement,
        provinceCityAgents,
		promotion
    ]
}

let loginRoute = {
    name: 'login',
    path: '/login',
    meta: {
        title: "登录",
        breadcrumb: true
    },
    component: (resolve) => require(['@/views/Login'], resolve)
};

export default [indexRoute, loginRoute]


// WEBPACK FOOTER //
// ./src/router/routes.js